<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '100px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                :value.sync="queryParams.planVersion"
                selectType="select"
                requestApi="/scp/scpMpsPlans/listMpsPlanVersion"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="例外分类">
              <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.exceptionType"
                selectType="selectMultiple"
                :selectData="exceptionTypeOpinions"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="变更天数范围">
              <a-input-number v-model="queryParams.changedDaysFrom" :min="0" />
              <span>  ~  </span>
              <a-input-number v-model="queryParams.changedDaysTo" :min="0" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="物料">
              <!-- <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.itemId"
                selectType="selectMultiple"
                :selectData="listSideOpinions"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              /> -->
              <global-select
                :value.sync="showItemIdQueryParams"
                :dropdown-match-select-width="false"
                selectType="selectAssembleSearch"
                requestApi="/mes/mesDiscreteJobs/assemblyBox"
                :selectItem="{ value: 'selectedValue', label: 'bringOutDataOne' }"
                searchParam="itemCode"
                @change="handleItemIdChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="供应商">
              <global-select
                :value.sync="queryParams.supplierIdList"
                selectType="selectMultipleSearch"
                searchParam="supplierName"
                requestApi="/scp/scpSopMpsSupplierCapacityLoad/supplierPullDown"
                :dropdown-match-select-width="false"
                :selectItem="{ value: 'realValue', label: 'selectedValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="状态">
              <!-- <global-select
                :value.sync="queryParams.supplierAbbreviation"
                selectType="select"
                requestApi="/mdm/mdmOrgSupplier/supplierAbbreviationList"
                :selectItem="{ value: 'label', label: 'label' }"
              /> -->
              <a-select v-model="queryParams.status" allowClear>
                <a-select-option v-for="(item) in stateOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport" type="primary">导出</a-button>
      <a-button :disabled="status!=='未发放'" :loading="isCalculating" @click="handleCalculationSelectAlert" >下发选中例外</a-button>
      <a-button :disabled="status!=='未发放'" :loading="isCalculating" @click="handleCalculationSelectAll">下发全部例外</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          @selectedRowChange="selectedRowChange"
          class="data-table"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MPS_EXCEPTION_DETAILS_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="version" slot-scope="{ record }">
            <a @click="handleGoDetail(record)" class="ml10">{{ record.version }}</a>
          </span>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
          <template slot="isStopFlag" slot-scope="{ record }">
            <span>{{ record.isStopFlag==='Y'?'是':'否' }}</span>
          </template>
          <template slot="specification" slot-scope="{ text }">
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{ text }}</span>
              </template>
              <span class="ellipsis">{{ text }}</span>
            </a-tooltip>
          </template >
          <!-- 变更类型 -->
          <template slot="changedTypeDesc" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.changedTypeDesc }}</span>
            <global-select
              v-else
              v-model="record.changedType"
              selectType="selectSearch"
              requestApi="/system/lookup/data/list"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              :setParams="{ lookupType: 'SCP_MPS_CHANGED_TYPE', attribute1: 'Y' }"
              :dropdown-match-select-width="false"
            />
          </template>
          <!-- 是否考核 -->
          <template slot="examineDesc" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.examineDesc }}</span>
            <global-select
              v-else
              v-model="record.examine"
              selectType="select"
              requestApi="/system/lookup/data/list"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              :setParams="{ lookupType: 'SCP_MPS_examine', attribute1: 'Y' }"
              :dropdown-match-select-width="false"
            />
          </template>
          <!-- 变更原因 -->
          <template slot="changedReasonDesc" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.changedReasonDesc }}</span>
            <global-select
              v-else
              v-model="record.changedReason"
              selectType="select"
              requestApi="/system/lookup/data/list"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              :setParams="{ lookupType: 'SCP_MPS_changed_reason', attribute1: 'Y' }"
              :dropdown-match-select-width="false"
            />
          </template>
          <!-- 责任方 -->
          <template slot="ownerDesc" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.ownerDesc }}</span>
            <global-select
              v-else
              v-model="record.owner"
              selectType="select"
              requestApi="/system/lookup/data/list"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              :setParams="{ lookupType: 'SCP_MPS_owner', attribute1: 'Y' }"
              :dropdown-match-select-width="false"
            />
          </template>
          <!-- 考核方 -->
          <template slot="examiner" slot-scope="{ record }">
            <a-tooltip placement="top" v-if="!isEdit || currentId !== record.id">
              <template slot="title">
                <span>{{ record.examiner }}</span>
              </template>
              <span class="examiner-name">{{ record.examiner }}</span>
            </a-tooltip>
            <global-select
              v-else
              v-model="record.examiner"
              selectType="selectSearch"
              requestApi="/mdm/mdmOrgSupplier/supplierNameList"
              :selectItem="{ value: 'realValue', label: 'realValue' }"
              searchParam="supplierName"
              :dropdown-match-select-width="false"
            />
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)">编辑</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
      </div>
    </template>

  </ls-table-layout>
</template>

          <script>
      import { generateLsTableResData } from '@/utils/util.js'
       import moment from 'moment';
       import { ApiDeleteScpMpsPlans } from '@/api/mps/basic-data/mps-option.js'
       import { apiScpSopExceptionsList, apiUpdateByBatchScpSopExceptionsList, apiUpdateByQueryScpSopExceptionsList, apiUpdateScpSopExceptions } from '@/api/mps/basic-data/mps-exception-details.js'

      export default {
        // eslint-disable-next-line
        name: 'Mps-exception-details',
        components: {
        },
        computed: {
        // 其他计算属性
        // ...
        formattedParams () {
          return {
            monthStart: moment(this.currentPeriod).format("YYYYMM")
            // monthEnd: moment(this.baseInfo.forecastPeriodTo).format("YYYYMM")
          };
        }
      },
        data () {
          return {
            advanced: true,
            status: '',
            isCalculating: false,
            exceptionTypeOpinions: [],
            listSideOpinions: [],
            moment: moment, // 在 data 中创建 moment 实例
            currentPeriod: '',
            isEdit: false,
            currentId: "",
            lookUpCode: '',
            // 表格多选
            selectedRowKeys: [],
            selectedRows: [],
            // 表格配置
            tableProps: {
              requestApi: generateLsTableResData(apiScpSopExceptionsList, true),
              pageCurrent: true
            },
            // 查询参数
            queryParams: {
                status: undefined,
                planVersion: undefined,
                supplierIdList: undefined,
                exceptionType: undefined,
                changedDaysTo: undefined,
                itemId: undefined,
                changedDaysFrom: undefined
            },
            showItemIdQueryParams: undefined,
            stateOptions: [
              {
                dictLabel: '未发放',
                dictValue: '未发放'
              },
              {
                dictLabel: '已发放',
                dictValue: '已发放'
              },
              {
                dictLabel: '不合格',
                dictValue: '不合格'
              },
              {
                dictLabel: '同步失败',
                dictValue: '同步失败'
              }
            ],
            // 表格字段
            columns: [
              {
                title: '物料编码',
                dataIndex: 'itemCode',
                ellipsis: true,
                width: 150,
                align: 'center',
                stickyFixed: 'left'
              },
              {
                title: '物料名称',
                width: 120,
                dataIndex: 'itemName',
                ellipsis: true,
                align: 'center',
                stickyFixed: 'left'
              },
              {
                title: '规格型号',
                width: 150,
                ellipsis: true,
                dataIndex: 'specification',
                scopedSlots: { customRender: 'specification' },
                align: 'left',
                stickyFixed: 'left'
              },
              {
                title: '例外类型',
                width: 170,
                dataIndex: 'exceptionTypeDesc',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '订单编号',
                width: 160,
                dataIndex: 'orderNumber',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '数量',
                width: 120,
                dataIndex: 'quantity',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '原日期',
                width: 120,
                dataIndex: 'oldScheduleDate',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '新日期',
                width: 120,
                dataIndex: 'newScheduleDate',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '变更天数',
                width: 120,
                dataIndex: 'changedDays',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '状态',
                width: 120,
                dataIndex: 'status',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '供应商',
                width: 120,
                dataIndex: 'supplierAbbreviation',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '是否停产',
                width: 120,
                dataIndex: 'isStopFlag',
                scopedSlots: { customRender: 'isStopFlag' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '变更类型',
                width: 120,
                dataIndex: 'changedTypeDesc',
                scopedSlots: { customRender: 'changedTypeDesc' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '是否考核',
                width: 120,
                dataIndex: 'examineDesc',
                scopedSlots: { customRender: 'examineDesc' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '变更原因',
                width: 120,
                dataIndex: 'changedReasonDesc',
                scopedSlots: { customRender: 'changedReasonDesc' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '责任方',
                width: 120,
                dataIndex: 'ownerDesc',
                scopedSlots: { customRender: 'ownerDesc' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '考核方',
                width: 150,
                dataIndex: 'examiner',
                scopedSlots: { customRender: 'examiner' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '来源',
                width: 120,
                dataIndex: 'source',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '备注',
                width: 180,
                dataIndex: 'comments',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '操作',
                width: 100,
                dataIndex: 'operation',
                scopedSlots: { customRender: 'operation' },
                stickyFixed: 'right'
              }
            ]
          }
        },
        created () {
          this.queryParams.planVersion = this.$route.query.id
         // this.getLastSalesForecast()
       //  this.getLookUpCode('SOP_PROCESS_STATU')
       this.getLookupList('SCP_MRP_EXCEPTION_TYPES', 'exceptionTypeOpinions')
       this.getLookupList('MDM_ORG_SUPPLIER_CLASS', 'listSideOpinions')
        },
        mounted () {
        //  this.onSearch()
          if (this.queryParams.planVersion) {
            this.onSearch()
          }
        },
        methods: {
          // 搜索框展开、收起
          toggleAdvanced () {
            this.advanced = !this.advanced
          },
        // 导入导出excel
          /** 导出按钮操作 */
         handleExport () {
            if (!this.queryParams.planVersion) {
              this.$message.error('请输入版本')
              return
           }
            this.download('scp/scpSopExceptions/export', {
              ...this.queryParams
            }, `例外信息列表_${new Date().getTime()}.xlsx`)
          },
        getLookupList (type, arr) {
            const lookupQueryParams = {
            lookupType: type,
            current: 1,
            pageSize: 100
            }
            this.getLookupListData(lookupQueryParams).then().then(response => {
            this[arr] = response.rows
            if (type === 'SCP_MRP_EXCEPTION_TYPES') {
                const filteredArray = response.rows.filter(function (obj) {
                    return obj.attribute2 === "Y";
                    });
                    this[arr] = filteredArray
            }
            })
        },
              // 新增/修改框事件
        handleOk () {
          this.onSearch()
        },
        handleCalculationSelectAll () {
          const self = this
          this.$confirm({
            title: '提示',
            content: '你确定下发所有记录吗？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk () {
              self.isCalculating = true
              apiUpdateByQueryScpSopExceptionsList(self.queryParams).then(response => {
                self.isCalculating = false
                if (response.code === 200) {
                  self.$message.success('下发成功')
                } else {
                  self.$message.error(response.msg)
                }
              }).catch((e) => { self.isCalculating = false })
            },
            onCancel () {
            }
          });
        },
          handleCalculationSelectAlert () {
                  /** 检查只能选择一个 */
                  if (this.selectedRows.length === 0) {
                    this.$message.error('请勾选需要下发的项')
                    return
                  }
                  const self = this
                  this.$confirm({
                    title: '提示',
                    content: '你确定下发该记录吗？',
                    okText: '确定',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk () {
                      self.handleCalculation()
                    },
                    onCancel () {
                    }
                  });
          },
          handleCalculation () {
            this.isCalculating = true
            const outputArray = this.selectedRowKeys.map((item) => {
              return {
                id: item
              };
            });
            apiUpdateByBatchScpSopExceptionsList(outputArray).then(response => {
              this.isCalculating = false

              if (response.code === 200) {
                this.$message.success('下发成功')
              } else {
                this.$message.error(response.msg)
              }
            }).catch((e) => { this.isCalculating = false })
          },
            getLookUpCode (code) {
                const lookupQueryParams = {
                    lookupType: code,
                    current: 1,
                    pageSize: 100
                }
                this.getLookupListData(lookupQueryParams).then().then(response => {
                // this.lookUpCode[code] = response.rows
                this.$set(this.lookUpCode, code, response.rows)
                })
            },
          resetQuery () {
            this.queryParams = {
                status: undefined,
                planVersion: undefined,
                supplierIdList: undefined,
                exceptionType: undefined,
                changedDaysTo: undefined,
                itemId: undefined,
                changedDaysFrom: undefined
            }
            this.showItemIdQueryParams = ''
            this.onSearch()
          },
          handleGoCapacityLoad () {
            /** 检查只能选择一个 */
            if (this.selectedRows.length > 1) {
              this.$message.error('产能负荷的选择项不能大于1')
              return
            }
            if (this.selectedRows.length === 0) {
              this.$message.error('请勾选其中一项')
              return
            }
            this.$router.push({ path: `/monthly-plan/capacityLoadPage/${this.selectedRows[0].monthPlanName}/${this.selectedRows[0].monthPlanVersion}/${this.selectedRows[0].id}` })
          },
          handleGoDemand () {
                    /** 检查只能选择一个 */
                    if (this.selectedRows.length > 1) {
              this.$message.error('生产需求的选择项不能大于1')
              return
            }
            if (this.selectedRows.length === 0) {
              this.$message.error('请勾选其中一项')
              return
            }
            this.$router.push({ path: `/monthly-plan/productionDemandPage/${this.selectedRows[0].monthPlanName}/${this.selectedRows[0].monthPlanVersion}/${this.selectedRows[0].id}` })
          },
          handleDel (record) {
            const self = this
            this.$confirm({
              title: '提示',
              content: '你确定删除该记录吗？',
              okText: '确定',
              okType: 'danger',
              cancelText: '取消',
              onOk () {
                self.deleteShipmentForecast(record)
              },
              onCancel () {
              }
            });
          },
          handleGoStatus (record) {
            this.$router.push({ path: `/shipmentForecastManagement/runningStatus/${record.id}` })
          },
          deleteShipmentForecast (record) {
          ApiDeleteScpMpsPlans(record.id).then((response) => {
              if (response.code === 200) {
                this.$message.success('删除成功')
                this.onSearch()
              } else {
                this.$message.error(response.msg)
              }
            })
          },
          handleGoDetail (record) {
            this.$router.push({ path: `/mps-work-desk/detail/${record.id}` })
          },
          handleEdit (record) {
            if (this.currentId && record.id !== this.currentId && this.isEdit) {
                  this.$message.warning('请保存上次编辑的数据')
                  return;
                }
                this.isEdit = true;
                this.currentId = record.id;
          },
          handleAdd () {
            this.$router.push({ path: `/monthly-plan/editPage/` })
          },
          /** 行选中 */
          selectedRowChange (selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys
            this.selectedRows = selectedRows
          },
          // 表单搜索
          onSearch () {
            if (!this.queryParams.planVersion) {
              this.$message.error('请输入版本')
              return
           }
            this.isEdit = false
            this.$refs.dataTable.searchParams = this.queryParams
            this.$refs.dataTable.getData()
            this.status = this.queryParams.status
          },
          // 编辑-保存
          handleSave (record) {
            apiUpdateScpSopExceptions(record).then(response => {
              if (response.code === 200) {
                this.$message.success('保存成功')
                this.onSearch()
              } else {
                this.$message.error(response.msg)
              }
            })
          },
          // 取消
          handleCancel (record) {
            this.isEdit = false
            this.onSearch()
          },
          statusOnChange (record) {
            record.netSubInventory = record.netSubInventory === 'Y' ? 'N' : 'Y'
          },
          handleItemIdChange (value, optionsList) {
            const selectedItem = optionsList.find(item => item.selectedValue === value)
            this.queryParams.itemId = selectedItem ? selectedItem.realValue : ''
          },
          handleChangeChangeType () {
            console.log(...arguments)
          }
        }
      }
      </script>

     <style scoped lang="less">
      .ml10 {
        margin-left: 10px;
      }/deep/.ant-input-number{
        width: 60px
      }
      .ellipsis{
        display:block;
        width:150px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .examiner-name {
        display:block;
        width:120px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .data-table {
        /deep/.ant-select {
          width: 100%;
        }
      }
      </style>
